/**
 * Validation helpers for the Complete the List game type.
 */

export function isValidListItem(item) {
  return (
    item &&
    typeof item.answer === 'string' &&
    item.answer.trim().length > 0
  );
}

export function getValidListItems(items) {
  if (!Array.isArray(items)) return [];
  return items.filter(isValidListItem);
}

const MIN_LIST_ITEMS = 3;

export function getCompleteListPublishError(options) {
  if (!options) return 'Game options are missing.';
  const title = options.listTitle;
  if (!title || typeof title !== 'string' || !title.trim()) {
    return 'A list title is required.';
  }
  const valid = getValidListItems(options.listItems);
  if (valid.length < MIN_LIST_ITEMS) {
    return `At least ${MIN_LIST_ITEMS} list items are required (${valid.length} valid).`;
  }
  return null;
}
